import React, { type FC } from 'react';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import { formatDateShortMonthYear } from '@/app/components/search/utils/dates/utilDates';
import { MonthButtonStyled } from './styled';

export type MonthButtonProps = {
  month: number;
  year: number;
};

const MonthButton: FC<MonthButtonProps> = ({ month, year }) => {
  const { localization } = usePageWrapperData();
  const { locale } = localization;
  const monthLabel = formatDateShortMonthYear(locale, `${year}-${month + 1}-01`);

  return <MonthButtonStyled>{monthLabel}</MonthButtonStyled>;
};

export default MonthButton;
